'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        padding: 7,
        borderRadius: variables.SIZES.BORDER_RADIUS,
        border: "1px solid transparent",
        "&.sprout-focus-visible": {
            borderColor: variables.COLORS.MISC_FOCUS_BORDER,
            boxShadow: `0 0 0 1px ${variables.COLORS.MISC_FOCUS_BORDER}`,
        },
        // Remove hover styling by increasing the specificity
        // Note that this will intentionally apply for ALL IconButton-based components
        // including radios, switches and checkboxes
        "&&&:hover": {
            backgroundColor: "transparent",
        },
    },
};

var MuiIconButton = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiIconButton = MuiIconButton;
exports.light = light;
